<script>
    import { createEventDispatcher ,onMount} from 'svelte';
    import {locale,language} from '../languages.js'
    import * as yup from 'yup'
    import Captcha from './Captcha.svelte';
    
    
    

    export let show_translation_btn = true
    export let hide_forget_link = false
    export let disable_guest_login = false
    // let phonePrefixes = [40,44,50,51,550,554,555,556,557,558,559,570,578,579,58,59,6,70,71,72,73,74,75,76,770,771,772,773,774,775,776,778,779,78,79,9];
    let phonePrefixes =['40', '44', '50', '51', '550', '554', '555', '556', '557', '558', '559', '570', '578', '579', '58', '59', '6', '70', '71', '72', '73', '74', '75', '76', '770', '771', '772', '773', '774', '775', '776', '778', '779', '78', '79', '9'];

    const baseUrl = location.origin
    let errors = {}
    const dispatch = createEventDispatcher();
    
    let formData = {
        username:null,
        password: null
    }

    let registerData = {
        username:null,
        name:null,
        email:null,
        telephone:null,
        password:null,
        role_id:0,
    }

    

    


    export let showRegisterForm = false

    let confirmPassword = null
    let captcha = -100
    let capAns;
    
    
    let registerSchema = yup.object().shape({
        username:yup.string().required(),
        name:yup.string().required(),
        email:yup.string().email().matches(/(\@gmail.com|\@hotmail.com|\@outlook.com|\@yahoo.com)/).required(),
        telephone:yup.string().min(8).max(8).matches(/\d{8}/).required().test('telephone','invalid phone number',
        (value,context ) => {
            
            let p = phonePrefixes.find(n=>{               
                return value.startsWith(n)
                
            })
            if(p) return true
            return false
            
        }),
        password:yup.string().required().min(6),
    })

    function extractErrors(err) {    
            return err.inner.reduce((acc, err) => {               
                return { ...acc, [err.path]: err.message };
            }, {});
        }

    async function submit(){
        if(!showRegisterForm){
            const o = {
                username:formData.username.trim(),
                password:formData.password,
            }
            dispatch('login',o)
        }
        else {
            if(!captcha) return 
            
            if(!(captcha == capAns)){
                errors.captcha = 'No Match'
                
                return
            }

            registerSchema.validate(registerData,{abortEarly:false})
            .then(()=>{
                errors = {}
                const o = {
                    username:registerData.username.trim(),
                    name:registerData.name.trim(),
                    password:registerData.password,
                    email:registerData.email.trim(),
                    telephone:registerData.telephone.trim(),
                    role_id:0,
                }
                dispatch('register',o)
            })
            .catch((err)=>{                
                errors = extractErrors(err)
                
            })
            
        }    
    }
    
    function loginAsGuest(){
        console.log('login as a guest')
        dispatch('login',{username:'guest',password:'guest'})
    }

    let toggleLang = ()=> { ($locale == 'en' || $locale== null)?locale.set('ar'):locale.set('en') }
    // $: disabled =  (formData.username == null || formData.username == '' || formData.password == null || formData.password == '')
    let disabled = false
    $: langLabel = $locale == 'ar'?'En':'ع'
    
 
    export let errorMessage = null
    $: hasError = (errorMessage == "" || errorMessage == null)?false:true


    function getCaptcha(e){        
        captcha  = e.detail.result
    }
    
</script>
<div class="bg-green-600 h-screen flex flex-col justify-center " 
     class:rtl={$locale == 'ar'}>   
    
     {#if showRegisterForm == false} 
        <div class="w-full flex flex-row justify-center justify-self-start mb-4 " style="height:200px;">        
                <svg width="150" height="200" viewBox="0 0 6 10" class="animate-pulse-slow">
                <path d="M 2.753913,1.7971036e-7 A 2.7558861,2.7558861 0 0 0 0,2.7559579 2.7558861,2.7558861 0 0 0 2.7559035,5.5118064 2.7558861,2.7558861 0 0 0 5.5118071,2.7559579 2.7558861,2.7558861 0 0 0 2.7559035,1.7971036e-7 a 2.7558861,2.7558861 0 0 0 -0.00199,0 z M 2.755903,0.46489792 c 1.2641494,-1.04e-6 2.2911139,1.02680228 2.2911139,2.29095168 0,1.2641487 -1.0269645,2.2911132 -2.2911139,2.2911132 -1.2641482,0 -2.29116787,-1.0269645 -2.29116735,-2.2911132 0,-1.2641494 1.02701945,-2.29095168 2.29116735,-2.29095168 z m 0,0.19904907 c -1.1565594,0 -2.09206407,0.93534201 -2.09206438,2.09190261 -5.2e-7,0.7589659 0.40284988,1.4226784 1.00665888,1.7893458 L 2.5047493,3.1831761 1.7342269,3.4380974 2.8153265,0.66545419 c -0.019795,-5.208e-4 -0.039493,-0.00151 -0.059424,-0.00151 z M 3.9421786,1.0323341 2.7429845,2.6887277 3.6918872,2.2721676 1.6825003,4.5520846 c 0.3137269,0.187682 0.6807589,0.2957753 1.0734021,0.2957753 1.1565593,0 2.0920641,-0.9354497 2.0920641,-2.0920103 0,-0.7157537 -0.3585422,-1.3464838 -0.9057879,-1.7235155 z M 2.8346503,6.0236398 c -0.3380702,0 -0.6102269,0.272158 -0.6102269,0.6102283 V 9.3897717 C 2.2244234,9.7278431 2.4965801,10 2.8346503,10 3.1727209,10 3.4448786,9.7278431 3.4448786,9.3897717 V 6.6338681 c 0,-0.3380703 -0.2721577,-0.6102283 -0.6102283,-0.6102283 z"
                fill="#fff"/>
                </svg>        
        </div>  
    {:else }
        <div class="w-full text-center text-2xl font-bold text-white mb-8">
            {#if $locale == 'ar' }
                <h3>إنشاء حساب</h3>
            {:else }
                <h3>Create Acccount</h3>
            {/if}    
        </div>
    {/if}
    {#if errorMessage}
    <div class="w-full text-center p-2 bg-white  text-red-500 mb-4" class:invisible={!hasError}>
        <h1> {errorMessage}</h1>    
    </div>    
    {/if}
    <form on:submit|preventDefault={submit} class="flex flex-row justify-center overflow-y-auto">
        <div class="w-11/12 sm:w-10/12 md:w-4/12 grid grid-row-3 gap-4">
            {#if !showRegisterForm }
                    <div class="">
                        <input type="text" placeholder={$language.label_username}  
                            bind:value={formData.username}>
                    </div>
                    <div >
                        <input type="password" placeholder={$language.label_password}
                        bind:value={formData.password} >                        
                    </div>           
            {:else}
                <div class="form-control">
                    <label for="username" class="text-white" >
                        <span>
                            {$language.label_username}:
                        </span>
                    </label>    
                    <input type="text" id="username" bind:value={registerData.username} class:has-errors={errors.username}>
                    <span class="px-2 text-red-600 bg-green-300">{errors.username?'قيمة غير صحيحة':''}</span>
                </div>        
                <div class="form-control">
                    <label for="name" class="text-white">
                        <span>
                            {$language.label_fullname }:
                        </span>
                    </label>    
                    <input type="text" id="name" bind:value={registerData.name} class:has-errors={errors.name}>
                    <span class="px-2 text-red-600 bg-green-300">{errors.name?'قيمة غير صحيحة':''}</span>
                </div>        
                <div class="form-control">
                    <label for="name" class="text-white">
                        <span>
                            {$language.label_email }:
                        </span>
                    </label>    
                    <input type="text" id="email" bind:value={registerData.email} 
                     class="text-left" class:has-errors={errors.email}>
                    <span class="px-2 text-red-600 bg-green-300">{errors.email?'قيمة غير صحيحة':''}</span>
                </div>        
                <div class="form-control">
                    <label for="name" class="text-white">
                        <span>
                            {$language.label_telephone }:
                        </span>
                    </label>    
                    <input type="text" id="telephone" bind:value={registerData.telephone} class:has-errors={errors.telephone}>
                    <span class="px-2 text-red-600 bg-green-300">{errors.telephone?'قيمة غير صحيحة':''}</span>
                </div>        
                <div class="form-control">
                    <label for="name" class="text-white">
                        <span>
                            {$language.label_password }:
                        </span>
                    </label>    
                    <input type="text" id="password" bind:value={registerData.password} class:has-errors={errors.password}>
                    <span class="px-2 text-red-600 bg-green-300">{errors.password?'كلمة المرور لا تقل عن 6 أحرف':''}</span>
                </div>        
                <!-- <div class="form-control">
                    <label for="name" class="text-white">
                        <span>
                            {$language.label_confirm_password }:
                        </span>
                    </label>    
                    <input type="text" id="username" bind:value={confirmPassword}>
                </div>         -->
                <div class="form-control">
                    <Captcha on:change={getCaptcha}/>
                    <input type="text" placeholder="{$locale == 'ar'?'أدخل النتيجة':'Enter result'}"
                    class:has-errors={errors.captcha}
                    bind:value={capAns}>
                    <span class="px-2 text-red-600 bg-green-300">{errors.captcha?'نتيجة حاطئة':''}</span>
                </div>
                <br>                
            {/if}
            <div  class="flex flex-row justify-center">                
                {#if !disabled }
                <div class="w-full">
                    <button type="submit" {disabled}
                            class="focus:outline-none  bg-green-500 hover:bg-green-300 text-white hover:text-black" >             
                    <span>{showRegisterForm?$language.btn_register:$language.btn_login}</span>   
                    </button>
                    {#if showRegisterForm == false}
                        <button on:click={()=>{showRegisterForm=true;errorMessage = ''}} 
                            class="my-2 underline underline-offset-8 text-green-300">
                            <span>{$language.btn_register}</span>
                        </button>
                    {:else }     
                        <div class="flex flex-row justify-center">
                            <div class="text-white underline underline-offset-8">
                                <button on:click={()=>{showRegisterForm = false}}
                                style="text-style:underline;">{$locale == 'ar' ? 'رجوع' : 'Back'}</button>
                            </div>
                        </div>     
                    {/if}
                </div>    
                {:else }
                    {#if !disable_guest_login }
                    <div class="w-full text-white text-xl text-center p-2">
                        <button on:click|preventDefault={loginAsGuest}>{ $language.label_login_as_guest }</button>
                    </div>
                    {/if}
                {/if}
                
            </div>
        </div>        
    </form>
    {#if !hide_forget_link}
    <h1 class="text-center text-white p-2 mx-10 underline">
        <a href="{baseUrl}/forgot?lang={$locale}">
            {$language.label_forgot_password}
        </a>
    </h1>
    {/if}
            
    
    {#if show_translation_btn && showRegisterForm == false}
        <div class="">
            <div class="lang-btn  bg-green-800 rounded-full h-16 w-16 pt-1 shadow-2xl" >
                <button on:click={toggleLang} class="focus:outline-none text-center text-white text-xl">
                    <span >{langLabel}</span>
                </button>
            </div>
        </div>    
    {/if}    
</div>

<style>
    
    .rtl  {
		direction: rtl;
	}

    .form-control {
        @apply  flex flex-col gap-2;
    }
    
    .form-control > input {
        height: 35px;
    }

    input, button {
        @apply rounded-lg py-3 px-6 w-full;
        @apply focus:outline-none focus:border-green-300;
    }

    input:focus , button:focus {
        border-style:solid;
        border-width:4px;
    }
    
    input::placeholder {
        font-size:18px;
        color:#444;
    }
    
    .lang-btn {
        position: absolute;
        bottom:20px;
        left:20px;        
    }

     .has-errors {
        color:#d55 !important;        
    }

    input.has-errors ,div.has-errors {
        border:solid thick #da8 !important;
    }
    
</style>